{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPIGroup} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/switch';
import statelyDocs from 'docs:@react-stately/toggle';
import Anatomy from '/packages/dev/s2-docs/pages/react-aria/SwitchAnatomy.svg';

export const section = 'Hooks';
export const description = 'Provides the behavior and accessibility implementation for a switch.';
export const isSubpage = true;

# useSwitch

<PageDescription>{docs.exports.useSwitch.description}</PageDescription>

```tsx render files={["starters/hooks/src/Switch.tsx", "starters/hooks/src/Switch.css"]}
"use client";
import {Switch} from 'hooks-starter/Switch';

<Switch>Low power mode</Switch>
```

## API

<Anatomy />

```tsx
<SwitchField>
  <SwitchButton>Label</SwitchButton>
  <Text slot="description" />
  <FieldError />
</SwitchField>
```

<FunctionAPIGroup
  functions={[
    {function: statelyDocs.exports.useToggleState, links: statelyDocs.links},
    {function: docs.exports.useSwitch, links: docs.links},
  ]}
/>

### ToggleState

<InterfaceType {...statelyDocs.exports.ToggleState} links={statelyDocs.links} />

### AriaSwitchProps

<InterfaceType {...docs.exports.AriaSwitchProps} />

### SwitchAria

<InterfaceType {...docs.exports.SwitchAria} />
